const ALLOWED_DEV_STATE_ENVIRONMENTS = new Set(['development', 'dev', 'local']);
const BLOCKED_DEV_STATE_ENVIRONMENTS = new Set(['production', 'prod', 'staging']);

function normalizeEnvironmentValue(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

export function isDevStateLabEnvironment(env = import.meta.env) {
  const mode = normalizeEnvironmentValue(env?.MODE);
  const appEnvironment = normalizeEnvironmentValue(env?.VITE_APP_ENVIRONMENT);

  if (
    BLOCKED_DEV_STATE_ENVIRONMENTS.has(mode) ||
    BLOCKED_DEV_STATE_ENVIRONMENTS.has(appEnvironment)
  ) {
    return false;
  }

  return Boolean(
    env?.DEV === true ||
      mode === 'development' ||
      ALLOWED_DEV_STATE_ENVIRONMENTS.has(appEnvironment),
  );
}
